import * as React from "react";
import PropTypes from "prop-types";
import { cn } from '../../utils/lib/utils';

const imageStyles = {
  base: "max-w-full h-auto",
  variants: {
    rounded: "rounded-lg",
    circle: "rounded-full",
    square: "rounded-none",
  },
  objectFit: {
    contain: "object-contain",
    cover: "object-cover",
    fill: "object-fill",
    none: "object-none",
  },
};

const Image = React.forwardRef(function Image(
  { className, src, alt, variant, fit, fallbackSrc, ...props },
  ref
) {
  const [error, setError] = React.useState(false);
  const [imageSrc, setImageSrc] = React.useState(src);

  React.useEffect(() => {
    setImageSrc(src);
    setError(false);
  }, [src]);

  const handleError = React.useCallback(() => {
    if (fallbackSrc) {
      setError(true);
    }
  }, [fallbackSrc]);

  const handleLoad = React.useCallback(() => {
    setError(false);
  }, []);

  return (
    <img
      ref={ref}
      src={error ? fallbackSrc : imageSrc}
      alt={alt}
      className={cn(
        imageStyles.base,
        variant && imageStyles.variants[variant],
        fit && imageStyles.objectFit[fit],
        className
      )}
      onError={handleError}
      onLoad={handleLoad}
      {...props}
    />
  );
});

Image.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(Object.keys(imageStyles.variants)),
  fit: PropTypes.oneOf(Object.keys(imageStyles.objectFit)),
  fallbackSrc: PropTypes.string,
};

export default Image;
